$(() => {
	const $body = $('body'),
		megaMenu = $('.max-mega-menu'),
		mainMenu = $('ul.mega-menu'),
		navBar = $('.navbar');

	// add "on-scrolled" class to body on page scroll
	const scrollTop = () => {
		const scroll = $(window).scrollTop();
		if (scroll >= 10) {
			$body.addClass('on-scrolled');
		} else {
			$body.removeClass('on-scrolled');
		}
		if ($('#wpadminbar').length > 0) {
			if (scroll >= 10) {
				$body.addClass('has-admin-bar');
			} else {
				$body.removeClass('has-admin-bar');
			}
		}
	};

	// loading functions on scroll, load
	$(window).on('scroll load', scrollTop);

	const innerWrapper = megaMenu.find('.mega-article-column');
	innerWrapper.each((index, element) => {
		$(element)
			.find('.mega-block-title, .more')
			.wrapAll('<div class="inner-wrapper" />');
		$(element).parents('.simple-image').append($('.inner-wrapper'));
	});

	mainMenu.each((index, element) => {
		$(element)
			.find('.mega-developers, .mega-request-a-demo')
			.wrapAll('<div class="menu-wrapper" />');
		const contents = $('.menu-wrapper').clone();
		$(navBar).append(contents);
	});
});
